import React, { useEffect, useState } from 'react'
import NameSection from '../../components/template/name-section'
import "./template.scss"
import { useSelector } from 'react-redux';
import TemplatePrescription from '../../components/template/main-prescription/template-prescription';
import { resolveActingDoctorId } from '../../utils/common-funtions/common';
const Template = () => {
    let { user, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
    // Doctors act as themselves; assistants/staff act on behalf of the selected doctor.
    const doctorId = resolveActingDoctorId({ user, selectedRole, selectedDoctor });
    const [selectedTemplate, setSelectedTemplate] = useState({})

    // When the acting doctor changes (assistant switches doctor), clear the open template.
    useEffect(() => {
        setSelectedTemplate({})
    }, [doctorId])

    return (
        <section className='template-section d-flex pt-3' style={{ marginLeft: "71px" }}>
            <div className='name-section'>
                <NameSection selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} doctorId={doctorId}></NameSection>
            </div>
            <div className='prescription-section'>
                {selectedTemplate?._id && <TemplatePrescription selectedTemplate={selectedTemplate} doctorId={doctorId}></TemplatePrescription>}
                {
                    !selectedTemplate?._id && <p>Please select a template from the list or create one</p>
                }
            </div>
        </section>
    )
}

export default Template

